import Table from './GeneralScrollTable';

export default Table;



// WEBPACK FOOTER //
// ./src/components/GeneralScrollTable/index.js